import { render, staticRenderFns } from "./AddDaywiseMachineStatusWidget.vue?vue&type=template&id=965fdade"
import script from "./AddDaywiseMachineStatusWidget.vue?vue&type=script&lang=js"
export * from "./AddDaywiseMachineStatusWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports